import { useState } from 'react';
import { Box, Tab, Tabs } from '@mui/material';
import { PageHeader } from '../../components/ui';
import TechChainCheckMui from './TechChainCheckMui';
import CoversPairsTab from './CoversPairsTab';

export default function CoversBindingMui() {
  const [tab, setTab] = useState('chain');
  return (
    <Box>
      <PageHeader
        title="Привязка чехлов"
        subtitle="Какие материалы техкарты учитывать в остатке на маркетплейсах, и пары для производства"
      />
      <Tabs value={tab} onChange={(_, v) => setTab(v)} sx={{ mb: 3, borderBottom: 1, borderColor: 'divider' }}>
        <Tab value="chain" label="Остатки по техкартам" />
        <Tab value="pairs" label="Пары для производства" />
      </Tabs>
      {tab === 'chain' ? <TechChainCheckMui /> : <CoversPairsTab />}
    </Box>
  );
}
